
const FAQTitleType = Symbol();

export class FAQTitle {
    [FAQTitleType]: any;
    readonly value: string;

    private constructor(faqTitle: string) {
        this.value = faqTitle;
    }

    static isInvalidSize(title: string): boolean {
        return title.length < 1 || title.length > 50;
    }

    static messageInvalidSize(label: string): string {
        return `${label}は1文字以上50文字以下で入力してください。`;
    }

    static fromString(faqTitle: string): FAQTitle {
        return new FAQTitle(faqTitle);
    }
}
